import { morphism } from 'morphism'
import { getRequest } from 'tfs.front-end-utils/requests'

import AirportModel from '../../models/Airport'

import airportSchema from '../../schemas/airport'

import staticData from '../../config/staticData'

import formatErrors from '../../utils/errors/formatErrors'

import { V1_REQUEST_AIRPORTS } from '../../actions/airports/v1requestAirports'
import v1receiveAirports from '../../actions/airports/v1receiveAirports'
import v1throwError from '../../actions/errors/v1throwError'
import getAuthenticationHeaders from '../../utils/requests/generateAuthorizationHeaders'

export default ({ dispatch }) => next => async action => {
  next(action)

  if (action.type !== V1_REQUEST_AIRPORTS) {
    return
  }

  const {
    endpoints: {
      allotments: { url, headers },
    },
  } = staticData

  try {
    const authHeaders = await getAuthenticationHeaders(headers)
    const fixedUrl = url.endsWith('/') ? url : `${url}/`
    const requestUrl = `${fixedUrl}airports`

    const response = await getRequest(
      requestUrl,
      { headers: { ...headers, ...authHeaders } },
      { requestCollection: true },
      formatErrors
    )

    const formattedAirports = response.map(airport => {
      return morphism(airportSchema, airport, AirportModel)
    })

    dispatch(v1receiveAirports(formattedAirports))
  } catch (error) {
    dispatch(v1throwError(error))
  }
}
